import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import DefRoutes from "../../../routes/routes.json";
import t from "../../../i18n/i18n";
import useApi from "../../../services/api";

function MyRequests() {
  const { ApiGetTicketsByUser } = useApi();

  const [tickets, setTickets] = useState([]);

  async function getMyTickets() {
    const { data } = await ApiGetTicketsByUser();

    setTickets(data);
  }

  useEffect(() => {
    getMyTickets();
  }, []);

  return (
    <div className="support-form-side">
      <div className="form-side-inner">
        <h4>{t("Support.MyRequests")}</h4>
        <ul className="side-box-form">
          {tickets.map((T, i) => {
            const { message } = T;
            const data = JSON.parse(message);
            return (
              <li>
                <Link to={DefRoutes.ViewTicket.replace(":id", T.id).replace(":order", i + 1)}>
                  <>
                    <strong>
                      {t("Support.TICKET")} {i + 1}
                    </strong>{" "}
                    {data.question}
                  </>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default MyRequests;
